import { Component, Vue } from 'vue-property-decorator';

@Component
export default class NaviSerchnaviLink extends Vue {
  private　name = 'NaviSerchnaviLink';
}
